/** @jsx jsx */
import { graphql, Link as GatsbyLink } from "gatsby"
import Img from "gatsby-image"
import { jsx, Container } from "theme-ui"
import { motion } from "framer-motion"
import { TheLayout, BouncingArrow } from "x"

const variants = {
  visible: { opacity: 1 },
  hidden: { opacity: 0 },
  reduced: { opacity: 0.5 },
}

//TODO: note this one is actually using container from theme-ui

const IndexPage = ({ data }) => {
  return (
    <TheLayout
      seoTitle="A Home Page"
      headerVariant="transparent"
      footerbg="white"
      sx={{ bg: "#262626" }}
    >
      <div
        sx={{
          display: "grid",
          alignItems: "center",
          height: "100%",
          position: "relative",
          zIndex: 1,
        }}
      >
        <Container>
          <motion.div
            initial="hidden"
            animate="visible"
            variants={variants}
            transition={{ ease: "easeInOut", duration: 2 }}
          >
            <h1
              sx={{
                fontSize: ["30px", "36px", "42px", "60px", "72px"],
                fontWeight: "400",
                lineHeight: "1.1",
                mt: 0,
                mb: 4,
                color: "white",
                textShadow: "0.12em 0.12em 0.12em rgba(0,0,0,0.2)",
                letterSpacing: "tight",
              }}
            >
              Everything you need to find and lease office space in Manhattan,
              Brooklyn &amp; New York City.
            </h1>

            <GatsbyLink
              to="/search-listings/"
              sx={{
                // fontFamily: theme.fonts.links,
                display: "inline-flex",
                alignItems: "center",
                color: "white",
                border: "3px solid #c41230",
                letterSpacing: "2px",
                textTransform: "uppercase",
                bg: "transparent",
                textAlign: "center",
                textDecoration: "none",
                m: 0,
                borderRadius: 0,
                fontSize: "18px",
                fontWeight: "500",
                px: 3,
                py: 3,
                lineHeight: 1,
              }}
            >
              Get Started <BouncingArrow />
            </GatsbyLink>
          </motion.div>
        </Container>
      </div>
      <motion.div
        initial="visible"
        animate="reduced"
        variants={variants}
        transition={{ ease: "easeInOut", duration: 3 }}
        sx={{
          position: "fixed",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          backgroundColor: "#000",
        }}
      >
        <Img
          fluid={data.coverImage.childImageSharp.also}
          title="words"
          style={{ position: "unset", overflow: "visible" }}
          backgroundColor="#F9D6CE"
        />
      </motion.div>
    </TheLayout>
  )
}

export default IndexPage

export const Alsoquery = graphql`
  query {
    coverImage: file(relativePath: { regex: "/osg-bg-taxis/" }) {
      childImageSharp {
        also: fluid(quality: 80) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
